import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignalWithTransform,
  Signal,
  ViewEncapsulation
} from '@angular/core';

import { BooleanInputType } from '../core';
import { TiimeIconModule } from '../icon';

type AlertColor = 'primary' | 'accent' | 'warn' | 'orange';
type AlertIcon = 'check_circle' | 'error' | 'info';

@Component({
  selector: 'tiime-alert',
  host: {
    /* eslint-disable @typescript-eslint/naming-convention */
    '[class.primary]': `color() === 'primary'`,
    '[class.accent]': `color() === 'accent'`,
    '[class.warn]': `color() === 'warn'`,
    '[class.orange]': `color() === 'orange'`,
    class: 'tiime-alert'
    /* eslint-enable @typescript-eslint/naming-convention */
  },
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TiimeIconModule]
})
export class AlertComponent {
  readonly displayIcon: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(true, {
    transform: booleanAttribute
  });
  readonly color = input<AlertColor>('primary');

  readonly alertIcon: Signal<AlertIcon> = computed<AlertIcon>(() => {
    switch (this.color()) {
      case 'accent':
        return 'check_circle';
      case 'warn':
        return 'error';
      default:
        return 'info';
    }
  });
}
